import React, { useEffect, useMemo, useState } from 'react';
import styles from './styles.module.scss';
import api from '@/api';
import { useParams } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import Button from '../ui/buttons/Button';
import { useMemoizedSelector } from '@/hooks/use-memoized-selector';
import { makeSelectEventById } from '@/models/event';
import { setCustomTheme, setPrimaryColor, setTextColor } from '@/utils/cssVars';
import { IContentTextStyleTypes, ILiveEventColorThemes } from '@/types';
import { useDispatch } from 'react-redux';
import Text, { ITextSizes } from '../ui/content/Text';

export const Certificate = () => {
  const { eventId = '' } = useParams<{ eventId: string }>();
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const event = useMemoizedSelector(makeSelectEventById, eventId);

  useEffect(() => {
    api.certificate.fetchCertificateHtml(eventId).then(res => {
      const html = res.data?.htmlContent;
      const elem = document.getElementById('cpe-certificate');

      if (elem && html) {
        elem.innerHTML = html;
      }
    });
  }, [eventId]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'event/getById',
      payload: {
        eventId: eventId,
      },
    });
  }, [eventId]);

  const colorTheme = useMemo(() => {
    if (event && event.colorTheme) {
      return ILiveEventColorThemes[event.colorTheme];
    }
    return ILiveEventColorThemes.LIGHT;
  }, [event.colorTheme]);

  useEffect(() => {
    if (!event) return;
    const { primaryColor, secondaryColor, colorTheme } = event;
    setPrimaryColor(primaryColor, secondaryColor);
    if (colorTheme === 'CUSTOM') {
      setCustomTheme(primaryColor, secondaryColor);
      setTextColor(primaryColor, `theme-${colorTheme}`);
    }
  }, [event]);

  const handleDownloadClick = async () => {
    setIsDownloading(true);
    const elem = document.getElementById('cpe-certificate');

    html2pdf(elem, {
      filename: 'certificate.pdf',
      // image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        proxy: 'https://app.staging.zuddl.io/proxy-img/',
      },
    }).finally(() => {
      setIsDownloading(false);
    });
  };

  return (
    <div id={`theme-${colorTheme}`}>
      <div className={styles['header']}>
        <p className={styles['certificateText']}>Certificate</p>
        <Button
          type={'button'}
          loading={isDownloading}
          onClick={handleDownloadClick}
        >
          <Text
            text={'Download'}
            textSize={ITextSizes.SMALL}
            textStyle={IContentTextStyleTypes.SEMI_BOLDED}
          />
        </Button>
      </div>

      <div className={styles['htmlContainer']}>
        <div id="cpe-certificate" />
      </div>
    </div>
  );
};
